import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

export interface AppleNotification {
  date: string;
  notification_type: string;
  requires_processing: number;
  count: number;
}

@Injectable()
export class ElectricityService {
  private API_ENDPOINT = `${environment.HOST}/adminapi/notification/`;

  constructor(private http: HttpClient) {}

  getNotification(days: number) {
    const url = `${this.API_ENDPOINT}getbydate/days/${days}`;
    return this.http.get(url).map(res => res as any);
  }
}



// WEBPACK FOOTER //
// /srv/dev/FitRadioAdmin2/src/app/@core/data/electricity.service.ts